import { Fragment, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { __MUNICIPALITY_API_URL__ } from 'shell/constants/environment';
import FormMunicipality, { MunicipalityForm } from 'system/geographic/components/municipality/form';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonMunicipalityCrumbs, validationSchemaForeign } from '../constants';
import { toast } from 'react-toastify';
import { transformRequestMunicipalityForeign } from 'system/geographic/utils/transformer-municipality-edit';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';

const MunicipalityNewPage = (): React.ReactElement => {
  const insertMunicipality = useHttpClient(`${__MUNICIPALITY_API_URL__}/geo/comune/straniero`, {
    options: {
      errorCatching: true,
      method: 'POST',
      loading: true,
    },
  });

  const navigate = useNavigate();

  const onSubmit = useCallback(
    (formValues: MunicipalityForm | undefined) => {
      const data = transformRequestMunicipalityForeign(formValues);
      (
        insertMunicipality({
          data,
        }) as ResponsePromise<void>
      ).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/sistema/geografiche/comune');
      });
    },
    [insertMunicipality, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonMunicipalityCrumbs, { name: 'Nuovo Comune Estero' }]} />
      <FormMunicipality
        title="Nuovo Comune Estero"
        onOk={onSubmit}
        validationSchema={validationSchemaForeign}
        isForeign
        onCancel={() => {
          navigate('/sistema/geografiche/comune');
        }}
      />
    </Fragment>
  );
};

MunicipalityNewPage.displayName = 'Municipality new foreign page component';

export default MunicipalityNewPage;
